// This file is used for maintain and manage API services.
(function() {
  'use strict';
  angular.module('obex').
  factory('singleSignOn', ['$http', 'obexConstant', 'authService',
    function($http, obexConstant, authService) {
      return {
        getSingleSignOnByOrganizationId(id) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlSingleSignOn}/organization/${id}`;
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },
        updateSingleSignOn(id, singleSignOn) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlSingleSignOn}/organization/id/${id}`;
            return $http.put(url, singleSignOn, {
              headers: authHeader,
            });
          });
        },    
        addSingleSignOn(singleSignOn, orgId) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const postData = {
              Id: 0,
              IdPURL: singleSignOn.IdPURL,
              Cert: singleSignOn.Cert,
              Code: singleSignOn.Code,
              OrganizationId: orgId,
            };
            return $http.post(obexConstant.urlSingleSignOn, postData, {
              headers: authHeader,
            });
          });
        },
      };
    },
  ]);
})();


// WEBPACK FOOTER //
// ./client/js/services/singleSignOn.service.js